// extracted by mini-css-extract-plugin
export default {"welcome-wrapper":"CreateClass_welcome-wrapper__IL7QO","description":"CreateClass_description__oBGym","fadeIn":"CreateClass_fadeIn__TjY4F","fadeOut":"CreateClass_fadeOut__WjIgp"};